import { enumToOptions } from '@app/shared/helpers';
import { Role } from '@app/shared/models/contracts/enums/shared-enums';

export const ROLE_OPTIONS = enumToOptions(Role, undefined, false);
